// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/shop-taxed-price-schema',
  type: 'object',
  required: ['unitGrossPrice', 'unitNetPrice', 'taxRate', 'taxAmount'],
  properties: {
    unitGrossPrice: {
      type: 'number',
    },
    unitNetPrice: {
      type: 'number',
    },
    taxRate: {
      type: 'number',
    },
    taxAmount: {
      type: 'number',
    },
    crmItemPriceNumber: {
      type: 'integer',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
